import React from 'react';
import { ArticleList } from '@components/common';
import { SectionTitle } from '../SectionTitle';
export const ArticleListSection = ({ title, articleList }) => (React.createElement("div", null,
    React.createElement(SectionTitle, { title: title }),
    React.createElement("div", null,
        React.createElement(ArticleList, { ...articleList }))));
